import React, {useEffect} from 'react';
import { useSelector } from 'react-redux';
import {Container} from 'semantic-ui-react';
import { Spin } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';
import InfiniteScroll from 'react-infinite-scroll-component';

import {
    fetchSearch,
    receiveSearch, SEARCH_CONTEXT_PRODUCTS,
    SEARCH_CONTEXTS,
    SEARCH_PAGE_COUNT
} from '../../features/search';
import {
    selectSearchFetching as getSearchFetching,
    selectSearch as getSearch,
    selectSearchHasMore as getHasMore,
    selectSearchToContext as getToContext,
    selectSearchFromContext as getFromContext
} from '../../features/search/selectors';

import {useSearchParams} from 'react-router-dom';

import "./style.css"
import {setWindowScrollPosition} from "../../components/WindowDimensions";
import ItemCard from "../../components/ItemCard";


export function isSearchView(pathname) {
    return pathname.indexOf('search') !== -1;
}
export default function Search(props) {

  const {routeAction, location, dispatch, token, userLocation, userData, mixpanel, isPageReloaded} = props;

  const [searchParams] = useSearchParams();
  const search = searchParams.get('q') || '';

  const loading = useSelector(getSearchFetching);
  const rawSearchItems = useSelector(getSearch);
  const searchItems = Array.isArray(rawSearchItems) ? rawSearchItems : [];
  const hasMore = useSelector(getHasMore);
  const fromContext = useSelector(getFromContext);
  const searchContext = useSelector(getToContext) || SEARCH_CONTEXT_PRODUCTS;

  const filteredProducts = searchItems.filter(product =>
        product.categories && product.categories.some(category => category.name === searchContext) && product !== false);

  const context = SEARCH_CONTEXTS('ru').find(obj => obj.value === fromContext);
  const contextTitle = context && typeof context === 'object' ? context.title : '';

  useEffect(() => {
      if (search) {
          window.scrollTo(0, 0);
          dispatch(receiveSearch(searchContext, 1, []));
          readSearch(1, searchContext);
      }
      if (mixpanel)
          mixpanel.track('Search List View',
              {...userLocation, ...userData, search, searchContext, fromContext, routeAction, ...location});
  }, [search, searchContext]);

  useEffect(() => {
        if (isPageReloaded) {
            setWindowScrollPosition();
        }
  }, [props]);

  const loadMore = () => readSearch(Math.round(searchItems.length / SEARCH_PAGE_COUNT) + 1, searchContext);

  const readSearch = (page, context)  => {
      const params = {
      search,
      page,
      per_page: SEARCH_PAGE_COUNT,
      order: 'asc',
      orderby: 'id',
  }

    dispatch(fetchSearch(token, context, params));
  }

  if (!navigator.onLine)
      return (<Container><p>Нет подключения к Интернету</p></Container>);

  const loaderText = `Ищем '${search}' ${contextTitle}...`;
  const displayItems = searchContext === 'products' ? searchItems : filteredProducts;

  const isInitialLoad = search && searchItems.length === 0 && fromContext !== searchContext;

  if (loading || isInitialLoad) {
      if (searchItems.length === 0 || fromContext !== searchContext) {
          return (
              <div className="page-loader" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, background: 'rgba(0,0,0,0.45)', zIndex: 199 }}>
                  <Spin indicator={<LoadingOutlined spin style={{ fontSize: 32, color: '#fff' }} />} />
                  <span style={{ color: '#fff', marginLeft: 12 }}>{loaderText}</span>
              </div>
          );
      }
  }

  if (displayItems.length === 0 && !loading && fromContext === searchContext) {
      return (
          <div className="search-page">
              <div className='search-header-banner'>
                  По запросу «{search}» {contextTitle} ничего не найдено
              </div>
          </div>
      );
  }

  return (
      <div className="search-page">
          <div className='search-header-banner'>
              Результаты поиска по запросу «{search}»
          </div>

          <InfiniteScroll
              dataLength={displayItems.length}
              next={loadMore}
              hasMore={hasMore}
              endMessage={
                  displayItems.length > 0 &&
                  <div className="product-page-end">
                      ✓ Все товары загружены
                  </div>
              }
              style={{ overflow: 'visible' }}
          >
              <div className="product-page-grid">
                  {displayItems.map((product) => (
                      <ItemCard
                          key={product.id}
                          item={product}
                          id={product.id}
                          main_image={product.images?.[0]?.src || product.main_image}
                          name={product.name}
                          short_description={product.short_description}
                          average_rating={product.average_rating}
                          rating_count={product.rating_count}
                          price={Number(product.price) || 0}
                          old_price={product.regular_price && Number(product.regular_price) > Number(product.price) ? Number(product.regular_price) : null}
                      />
                  ))}
              </div>
              <div style={{ textAlign: 'center', padding: '20px 0' }}>
                  <Spin indicator={<LoadingOutlined spin style={{ color: '#DC0202', fontSize: 24 }} />} />
              </div>
          </InfiniteScroll>
      </div>
  );
}
